export default __webpack_public_path__ + "static/img/logo-animation.0ab042e.gif";